import SellerDependentView from "./SellerDependentView";

export default SellerDependentView;
